import type {
  ReferentialModelState,
  ReferentialStateEndpoint,
} from "./referential-states.type";
import type { UseReferentialOptions } from "../referential.type";
import type { TransitionableStateModelType } from "@/entities/state";

import { useReferential } from "../referential.query";

import { getReferentialStateEndpointFromType } from "./referential-states.helper";

export const useReferentialStates = <
  T extends ReferentialModelState = ReferentialModelState,
>(
  endpoint: ReferentialStateEndpoint,
  options?: UseReferentialOptions<T[]>
) => {
  const { data = [], ...result } = useReferential<T[]>(endpoint, options);

  // Always sort states by index
  const states = data.sort((stateA, stateB) => stateA.index - stateB.index);

  const getState = (
    value: string,
    key: keyof ReferentialModelState = "slug"
  ) => {
    return states.find((s) => s[key] === value);
  };

  return {
    ...result,
    getState,
    states,
  };
};

export const useReferentialTypeStates = (
  type: TransitionableStateModelType
) => {
  const endpoint = getReferentialStateEndpointFromType(type);

  return useReferentialStates(endpoint);
};
